import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import LoadingOverlay from "../overlays/LoadingOverlay";
import { useSelector } from "react-redux";

// Sandbox plan IDs — swap these for production plan IDs when going live
const PLAN_IDS = {
  monthly:   "P-8F463117SV747581MNBYN34Q",   // sandbox monthly
  quarterly: "P-05799457JN448591YNBYN4SI",   // sandbox quarterly
  annually:  "P-0CJ434567A9539157NBYN5CA",   // sandbox annually
};

const PLANS = [
  {
    key: "annually",
    label: "Annual",
    price: "$99.99",
    amount: "99.99",
    planId: "P-9UD23566YK358804UNC5L4AY",  // Live 
    // planId: "P-0CJ434567A9539157NBYN5CA",  // sandbox 
    version: "Annual",
  },
  {
    key: "quarterly",
    label: "Quarterly",
    price: "$29.99",
    amount: "29.99",
    planId: "P-4JC54175F9111384UNC5L3BQ",   // live
    // planId: "P-05799457JN448591YNBYN4SI",   // sandbox
    version: "Quarterly",
  },
  {
    key: "monthly",
    label: "Monthly",
    price: "$14.99",
    amount: "14.99",
    planId: "P-6JT4898664885221BNC5LZ4A",    // live
    // planId: "P-8F463117SV747581MNBYN34Q",    // sandbox
    version: "Monthly",
  },
];

export default function QuillionzProUpgradeModal({ isOpen, onClose }) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const { user } = useSelector((state) => state.users);

  const handleModalClose = () => {
    if (isLoading) return; // prevent close while redirecting
    setError("");
    onClose();
  };

  const handlePlanSelect = async (plan) => {
    setError("");
    setIsLoading(true);

    try {
      const email = localStorage.getItem("email");
      const userId = localStorage.getItem("Id");
      const firstName = localStorage.getItem("username") || "Quillionz";
      const lastName = "User";

      const payload = {
        UserId: userId,
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Amount: plan.amount,
        Version: plan.version,
        PlanId: plan.planId,
      };

      console.log("payload from frontend:-",payload);
      
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/paypal/app/paypalsubscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();

      // The backend returns { approvalUrl: "https://www.paypal.com/..." }
      const approvalUrl = data.approvalUrl;

      if (!approvalUrl) {
        throw new Error("No approval URL returned from server.");
      }

      // Redirect user to PayPal
      window.location.href = approvalUrl;
    } catch (err) {
      console.error("PayPal subscription error:", err.message);
      setError(
        err.message || "Something went wrong. Please try again."
      );
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isOpen}
        onClose={handleModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={isOpen}>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="bg-white shadow-2xl rounded-lg animate-fade-slide-down w-80">
              {/* Header */}
              <div className="flex place-content-between mx-3 p-[0.35rem] pt-2 border-b">
                <h2 className="text-lg font-semibold">Subscribe To Quillionz GPT</h2>
                <Tooltip
                  title="Close"
                  arrow
                  placement="top"
                  TransitionComponent={Zoom}
                  TransitionProps={{ timeout: 300 }}
                >
                  <button
                    className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full"
                    onClick={handleModalClose}
                    disabled={isLoading}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </Tooltip>
              </div>

              {/* Plan Buttons */}
              <div className="flex flex-col text-center px-6 py-4 gap-2">
                {PLANS.map((plan, idx) => (
                  <React.Fragment key={plan.key}>
                    <Tooltip
                      title={`Subscribe ${plan.label} — ${plan.price}`}
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        onClick={() => handlePlanSelect(plan)}
                        disabled={isLoading}
                        className={`w-full py-2 px-4 rounded text-white font-medium transition-opacity
                          ${isLoading
                            ? "bg-[#0c3f5a] cursor-not-allowed opacity-70"
                            : "bg-[#f4833d] hover:opacity-90"
                          }`}
                      >
                        {isLoading
                          ? "Redirecting to PayPal..."
                          : `${plan.label} (${plan.price})`}
                      </button>
                    </Tooltip>
                    {idx < PLANS.length - 1 && (
                      <p className="text-xs text-gray-400 my-1">— OR —</p>
                    )}
                  </React.Fragment>
                ))}

                {error && (
                  <p className="text-red-500 text-sm mt-2">{error}</p>
                )}
              </div>
            </div>

            {isLoading && <LoadingOverlay />}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}